import { useQuery } from '@tanstack/react-query';
import ApprovalsService from 'src/services/approvals.service';

export const useDetailsQuery = (params: {
  eventType: string;
  personnelNumber: string;
  companyId: string;
  summaryId?: string;
}) => {
  const results = useQuery(['approvals/details'], async () => {
    const result = await ApprovalsService.getDetails({
      eventType: params.eventType,
      personnelNumber: params.personnelNumber,
      companyId: params.companyId || '',
      summaryId: params.summaryId,
    });
    return result;
  });
  return results;
};
